import {
  IKeyValueInterface,
  PermissionType,
  DataListModel,
  WeGoAuthorizedLink,
  Permission
} from "./../../shared/config";
import { AuthService } from "./../../shared/models/auth.service";
import { TranslateService } from "./../../shared/translate/translate.service";
import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL
} from "../../shared/config";
import { Location } from "@angular/common";
import { InvoiceService } from "../models/invoice.service";
import { InvoiceModel } from "../models/invoice.model";
import { InstanceService } from "../../instance/models/instance.service";
import { CompanyService } from "../../company/models/company.service";
import { DropdownModel } from "../../report/models/report-filter.model";
import { CostAndExpenseModel } from "../../cost-expenses/models/cost-expense.model";
import { RoundingFormatterService } from "../../shared/models/rounding-formatter.service";

@Component({
  selector: "wego-invoice",
  template: require('../views/invoice-update.component.html'),
  providers: [InvoiceService, InstanceService, CompanyService],
  styles: [
    `
      .form-horizontal .control-label {
        text-align: left;
      }
    `
  ]
})
export class InvoiceUpdateComponent implements OnInit, OnDestroy {
  invoiceLine: string;
  deleteMessage: string;
  companyList: DropdownModel[];
  instanceList: DropdownModel[];
  reportName: string;
  private invoiceHashId: string;
  private sub: any;
  public model: InvoiceModel;
  private apiResponse: IAPIResponse;
  public errorModel: IKeyValueInterface[];
  private errorMessage: string;
  private message: string;
  private isEditMode: boolean;
  private popupMsg: string;
  private module: string;
  breadCrumbTitle: string;
  breadCrumbList: string;
  public searchField: string = "";
  public searchTerm: string = "";
  public selectedInstance: string = "";
  public isNew: boolean;
  DataListModel: DataListModel = new DataListModel();
  removeCostAndExpensehashId: string;
  removeCostAndExpenseinvoicehashId: string;
  public isEditable: boolean = true; //todo : set For readonly

  public costAndExpensesList: CostAndExpenseModel[] = [];
  confirmMsg: string;
  urlDefaultPage: string;
  urlCustomerList: string;
  isLoading: boolean;

  public get addresseeEnabled(): boolean {
    if (this.model.isSenderInstance) {
      return !!this.model.senderInstanceHashId;
    }
    if (!this.model.isSenderInstance) {
      return (
        !!this.model.senderInstanceHashId && !!this.model.senderCompanyHashId
      );
    }
  }

  @ViewChild("successPopup") public successPopup: any;
  @ViewChild("removesuccessPopup") public removesuccessPopup: any;
  @ViewChild("sendConfirmModal") public sendConfirmModal: any;
  @ViewChild("manualInvoiceLine") public manualInvoiceLine: any;
  @ViewChild("confirmModal") public confirmModal: any;
  @ViewChild("manualInvoiceLineUpdate") public manualInvoiceLineUpdate: any;
  @ViewChild("costAndExpensePopup") public costAndExpensePopup: any;

  constructor(
    private invoiceService: InvoiceService,
    private instanceService: InstanceService,
    private companyService: CompanyService,
    private translate: TranslateService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private locationService: Location,
    private roundFormatterService: RoundingFormatterService
  ) {}

  ngOnInit() {
    this.module = this.translate.instant("LblInvoice");
    this.invoiceLine = this.translate.instant("LblInvoiceLine");
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlCustomerList = this.authService.GetURL(
      ApplicationRouteURL.URL_BOOKING_INVOICE_LIST
    );
    this.reportName = "invoice_update";
    this.isEditMode = false;
    this.model = new InvoiceModel();
    this.GetAllInstanceList();
    this.GetInvoiceDetails();

  }

  public GetInvoiceDetails() {
    this.sub = this.activeRoute.params.subscribe(params => {
      this.invoiceHashId = params["id"] || "";
      if (this.invoiceHashId != "") {
        this.isEditMode = true;
        this.invoiceService
          .GetManualInvoiceByHashId(this.invoiceHashId)
          .subscribe(
          res => {
            this.model = res.data;
            if (!this.model.isSenderInstance) {
              this.GetAllCompanyList();
            }
            this.SetSenderAddress();
            this.SetAddreseeAddress();
          },
          error => {
            this.errorMessage = this.authService.HandleErrorStatusCode(error);
          }
          );
      } else {
        this.GetInvoiceNumber();
      }
    });
    this.breadCrumbTitle = this.isEditMode
      ? this.translate.instant("LblEditPage", [this.module])
      : this.translate.instant("LblAddPage", [this.module]);
    this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
  }

  private GetInvoiceNumber() {
    this.invoiceService.GetInvoiceNumber().subscribe(
      res => {
        this.model.invoiceNumber = res.data;
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  private SetSenderAddress() {
    if (this.model.isSenderInstance) {
      // todo : Implement Instance Address
      this.model.senderAddress = "";
    } else {
      this.GetCompanyAddress();
    }
  }

  private SetAddreseeAddress() {
    if (this.model.addresseeType == "DRIVER") {
      this.GetDriverAddress();
    } else {
      this.GetOrganizationAddress();
    }
  }

  private GetCompanyAddress() {
    if (this.model.senderCompanyHashId) {
      this.invoiceService
        .GetCompanyAddress(this.model.senderCompanyHashId)
        .subscribe(
        res => {
          this.model.senderAddress = res.data;
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        }
        );
    }
  }

  private GetDriverAddress() {
    this.invoiceService.GetDriverAddress(this.model.driverHashId).subscribe(
      res => {
        this.model.addresseeAddress = res.data;
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  private GetOrganizationAddress() {
    this.invoiceService
      .GetOrganizationAddress(this.model.organizationHashId)
      .subscribe(
      res => {
        this.model.addresseeAddress = res.data;
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      }
      );
  }

  public OnSaveClick() {
    this.invoiceService.UpdateManualInvoice(this.model).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.isEditMode
            ? this.translate.instant("LblRecordUpdatedSuccess", [this.module])
            : this.translate.instant("LblRecordAddedSuccess", [this.module]);
          this.ShowSuccessPopup();
        } else {
          this.errorModel = res.error;
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  private getPermissionType() {
    if (this.isEditMode) {
      if (this.invoiceHashId) {
        return PermissionType.EDIT;
      } else {
        return PermissionType.INSERT;
      }
    } else {
      return PermissionType.VIEW;
    }
  }

  public GetAllInstanceList() {
    this.instanceService
      .GetInstanceListDropdownForAddUpdatePage(
      this.reportName,
      this.getPermissionType()
      )
      .subscribe(
      res => {
        this.instanceList = res.data;

        if (this.instanceList && this.instanceList.length > 0) {
          if (
            !this.model.senderInstanceHashId &&
            this.instanceList.length == 1
          ) {
            this.model.senderInstanceHashId = this.instanceList[0].keyHash;
            this.model.senderName = this.instanceList[0].value;
            this.OnInstanceChange();
          }
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      }
      );
  }

  public OnInstanceChange() {
    this.model.senderCompanyHashId = "";
    if (!this.model.isSenderInstance) {
      if (this.model.senderInstanceHashId) {
        this.GetAllCompanyList();
      } else {
        this.companyList = [];
      }
    } else {
      this.model.senderName = this.instanceList.find(
        x => x.keyHash == this.model.senderInstanceHashId
      ).value;
      //TODO: Set Instance Address function
      this.model.senderAddress = "";
    }

    if (!this.invoiceHashId) {
      this.model.costAndExpenseList = [];
    }
  }

  public SenderChange() {
    if (!this.model.isSenderInstance) {
      this.model.senderName = this.companyList.find(
        x => x.keyHash == this.model.senderCompanyHashId
      ).value;
      this.GetAllCompanyList();
    } else {
      this.model.senderName = this.instanceList.find(
        x => x.keyHash == this.model.senderInstanceHashId
      ).value;
      this.model.senderCompanyHashId = "";
      this.model.senderAddress = "";
    }
  }

  public GetAllCompanyList() {
    this.companyService
      .GetCompanyListDropdownForAddUpdatePage(
      this.reportName,
      this.getPermissionType(),
      this.model.senderInstanceHashId
      )
      .subscribe(
      res => {
        this.companyList = res.data;
        if (this.companyList && this.companyList.length > 0) {
          if (
            !this.model.senderCompanyHashId &&
            this.companyList.length == 1
          ) {
            this.model.senderCompanyHashId = this.companyList[0].keyHash;
            this.GetCompanyAddress();
          }
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      }
      );
  }

  public OnCompanyChange() {
    if (!this.model.isSenderInstance) {
      this.model.senderName = this.companyList.find(
        x => x.keyHash == this.model.senderCompanyHashId
      ).value;
      this.GetCompanyAddress();
    }

    if (!this.invoiceHashId) {
      this.model.costAndExpenseList = [];
    }
  }

  public SuccessSelectDriverModal(event: any) {
    this.model.driverHashId = event.DriverHashID;
    this.model.sharedVehicleGroupDriverHashId = event.SharedVehicleGroupDriverHashId;
    this.model.driverName = event.DriverName;
    this.model.addresseeName = event.DriverFullName;
    this.GetDriverAddress();

    if (!this.invoiceHashId) {
      this.model.costAndExpenseList = [];
    }
  }

  public SuccessSelectOrganizationModal(event: any) {
    this.model.organizationHashId = event.OrganizationHashID;
    this.model.organizationName = event.OrganizationName;
    this.model.addresseeName = event.OrganizationName;
    this.GetOrganizationAddress();

    if (!this.invoiceHashId) {
      this.model.costAndExpenseList = [];
    }
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ShowRemoveSuccessPopup(): void {
    this.removesuccessPopup.show();
  }

  public HideRemoveSuccessPopup(): void {
    this.removesuccessPopup.hide();
  }

  public ConfirmRemoveSuccessPopup(): void {
    this.removesuccessPopup.hide();
  }

  public OnBackClick() {
    this.locationService.back();
  }

  public AddManualInvoiceLine() {
    if (this.model.driverHashId || this.model.organizationHashId) {
      this.manualInvoiceLine.model = new CostAndExpenseModel();

      this.manualInvoiceLine.model.recipientOrganizationHashId = this.model.organizationHashId;
      this.manualInvoiceLine.model.recipientDriverHashId = this.model.driverHashId;
      this.manualInvoiceLine.model.reportedByDriver = false;
      this.manualInvoiceLine.model.chargeToDriver =
        this.model.addresseeType == "DRIVER";
      this.manualInvoiceLine.model.sharedVehicleGroupDriverHashId = this.model.sharedVehicleGroupDriverHashId;
      this.manualInvoiceLine.model.module = "INVOICE";
      this.manualInvoiceLine.SelectedExpenseHashIdList = this.model.costAndExpenseList.map(
        y => y.costAndExpenseHashId
      );
      this.manualInvoiceLine.show();
    }
  }

  public ManualInvoiceLineSuccess(event: any) {
    if (event.CostAndExpenseModel) {
      var cost = event.CostAndExpenseModel;
      this.model.costAndExpenseList.push(cost);
    } else {
      var costList = event.CostAndExpenseModelList;
      this.model.costAndExpenseList = this.model.costAndExpenseList.concat(
        costList
      );
    }
  }

  // private OnAddreseeChange() {
  //   if (this.model.addresseeType == "DRIVER") {
  //     this.GetDriverAddress();
  //   } else {
  //     this.GetOrganizationAddress();
  //   }
  // }

  public ShowConfirmModal(
    costAndExpensehashId: string,
    invoicehashId: string
  ): void {
    this.removeCostAndExpensehashId = costAndExpensehashId;
    this.removeCostAndExpenseinvoicehashId = invoicehashId;
    this.deleteMessage = this.translate.instant("LblRecordDeleteConfirmation", [
      this.invoiceLine
    ]);
    this.confirmModal.show();
  }

  public ConfirmSuccessClick(): void {
    this.confirmModal.hide();

    this.RemoveCostAndExpenses(this.removeCostAndExpensehashId);
  }

  public HideConfirmModal(): void {
    this.removeCostAndExpensehashId = "";
    this.removeCostAndExpenseinvoicehashId = "";
    this.confirmModal.hide();
  }

  private RemoveCostAndExpenses(removeCostAndExpensehashId: string) {
    if (this.removeCostAndExpenseinvoicehashId) {
      this.invoiceService
        .RemoveCostAndExpenses(removeCostAndExpensehashId)
        .subscribe(
        res => {
          if (res.data) {
            var costExpenseIndex = this.model.costAndExpenseList.findIndex(
              x => x.costAndExpenseHashId == removeCostAndExpensehashId
            );
            if (costExpenseIndex > -1) {
              this.model.costAndExpenseList.splice(costExpenseIndex, 1);
            }

            this.popupMsg = this.translate.instant(
              "LblRecordRemovedSuccess",
              [this.invoiceLine]
            );
            this.ShowRemoveSuccessPopup();
          } else {
            this.errorModel = res.error;
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        }
        );
    } else {
      var costExpenseIndex = this.model.costAndExpenseList.findIndex(
        x => x.costAndExpenseHashId == removeCostAndExpensehashId
      );
      if (costExpenseIndex > -1) {
        this.model.costAndExpenseList.splice(costExpenseIndex, 1);
        this.popupMsg = this.translate.instant("LblRecordRemovedSuccess", [
          this.invoiceLine
        ]);
        this.ShowRemoveSuccessPopup();
      }
    }
  }

  public ShowSendConfirmModal(): void {
    this.confirmMsg = this.translate.instant("LblSendInvoiceConfirm", [
      this.module
    ]);
    this.sendConfirmModal.show();
  }

  public SuccessConfirmModalClick(): void {
    this.sendConfirmModal.hide();
    this.OnSendClick();
  }

  public HideSendConfirmModal(): void {
    this.sendConfirmModal.hide();
  }

  public OnSendClick() {
    this.isLoading = true;
    this.invoiceService.UpdateManualInvoice(this.model, true).subscribe(
      res => {
        if (res.data) {
          this.isLoading = false;
          this.popupMsg = this.translate.instant("LblInvoiceSent");
          this.ShowSuccessPopup();
        } else {
          this.errorModel = res.error;
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public ShowUpdateManualInvoiceLinePopup(expense: CostAndExpenseModel) {
    this.manualInvoiceLineUpdate.model = expense;
    this.manualInvoiceLineUpdate.model.recipientOrganizationHashId = this.model.organizationHashId;
    this.manualInvoiceLineUpdate.model.recipientDriverHashId = this.model.driverHashId;
    this.manualInvoiceLineUpdate.model.sharedVehicleGroupDriverHashId = this.model.sharedVehicleGroupDriverHashId;
    this.manualInvoiceLineUpdate.model.module = "INVOICE";
    // this.manualInvoiceLineUpdate.model.reportedByDriver = false;
    this.manualInvoiceLineUpdate.model.chargeToDriver =
      this.model.addresseeType == "DRIVER";

    if (!expense.reportedByDriver) {
      this.manualInvoiceLineUpdate.show(this.model.status == "OPEN");
    } else {
      if (this.model.status == "OPEN") {
        expense.isEditable = true;
        expense.isDescCostTypeOnlyEdit = true;
      } else {
        expense.isEditable = false;
        expense.isDescCostTypeOnlyEdit = false;
      }
      this.costAndExpensePopup.show(expense);
    }
  }

  public ManualInvoiceLineUpdateSuccess($event: any) {
    console.log($event);
    let cost = $event.CostAndExpenseModel;
    let costExpenseIndex = this.model.costAndExpenseList.findIndex(
      x => x.costAndExpenseHashId == cost.costAndExpenseHashId
    );
    if (costExpenseIndex >= 0) {
      this.model.costAndExpenseList[costExpenseIndex] = cost;
    }
  }

  get totalAmountExVatFormat(): string {
    var totalAmount: number = 0;
    totalAmount = this.model.costAndExpenseList
      .map(x => parseFloat(x.approvedAmountExVat.toString().replace(",", ".")))
      .reduce((sum, item) => sum + item, 0);
    return totalAmount == 0 ? "" : totalAmount.toString();
  }

  get totalAmountInVatFormat(): string {
    var totalAmountInVat: number = 0;
     totalAmountInVat = this.model.costAndExpenseList
       .map(x => parseFloat(x.approvedAmountInVat.toString().replace(",", ".")))
       .reduce((sum, item) => sum + item, 0);
    return totalAmountInVat == 0 ? "" : totalAmountInVat.toString();
  }

  get totalVatAmountFormat(): string {
    var totalAmount: number = 0;
    totalAmount = this.model.costAndExpenseList
      .map(x => parseFloat(x.approvedAmountVat.toString().replace(",", ".")))
      .reduce((sum, item) => sum + item, 0);
    return totalAmount == 0 ? "" : totalAmount.toString();
  }

  get vatSummary(): any {
    let finalGroup: any;
    let groups = this.GroupByVATPercentage(this.model.costAndExpenseList);

    let vatSummary: any[] = [];
    for (let block in groups) {
      let vatBlock = {};
      vatBlock["percentage"] = block;
      vatBlock["totalAmountExVat"] = groups[block]
        .map((x: any) => parseFloat(x.approvedAmountExVat.toString().replace(",", ".")))
        .reduce((sum: any, item: any) => sum + item, 0);

      vatBlock["totalAmountExVat"] = this.roundFormatterService.transform(
        vatBlock["totalAmountExVat"]
      );

      vatBlock["totalVatAmount"] = groups[block]
        .map((x: any) => parseFloat(x.approvedAmountVat.toString().replace(",", ".")))
        .reduce((sum: any, item: any) => sum + item, 0);

      vatBlock["totalVatAmount"] = this.roundFormatterService.transform(
        vatBlock["totalVatAmount"]
      );

      vatSummary.push(vatBlock);
    }

    return vatSummary;
  }

  public GroupByVATPercentage(selectedCostExpenseList: CostAndExpenseModel[]) {
    if (selectedCostExpenseList) {
      let prop = "approvedVatPercentage";
      return selectedCostExpenseList.reduce(function(groups: any, item: any) {
        let vatPercentage = item[prop];
        groups[vatPercentage] = groups[vatPercentage] || [];
        groups[vatPercentage].push(item);
        return groups;
      }, {});
    } else {
      return {};
    }
  }

  public KeyOfObject(obj: any) {
    return Object.keys(obj);
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/invoice/components/invoice-update.component.ts